<template>

  <div id="app">
    <!-- <link rel="stylesheet" href="https://maxcdn.icons8.com/fonts/line-awesome/1.1/css/line-awesome-font-awesome.min.css"/>-->
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.1.1/css/all.min.css" integrity="sha512-KfkfwYDsLkIlwQp6LFnl8zNdLGxu9YAA1QvwINks4PhcElQSvqcyVLLD9aMhXd13uQjoXtEKNosOWaZqXgel0g==" crossorigin="anonymous" referrerpolicy="no-referrer" />
    
   <!-- <header class="hero" v-if="!['LoginView', 'register', 'help'].includes($route.name)">
      <link rel="stylesheet" href="https://maxcdn.icons8.com/fonts/line-awesome/1.1/css/line-awesome-font-awesome.min.css">
      <div class="hero-head">
        <nav
          class="navbar has-shadow"
          role="navigation"
          aria-label="main navigation"
        >
          <div class="navbar-brand">
            <a class="navbar-item is--brand">
              <img
                class="navbar-brand-logo"
                src="@/assets/logo.png"
                alt="Brand logo"
              />
            </a>
            <button class="button navbar-burger" data-target="navMenu">
              <span></span> <span></span> <span></span>
            </button>
          </div>
          <div class="navbar-menu navbar-end" id="navMenu">
            <a class="navbar-item nav-tag">
              <span class="icon is-small">
                <i class="fa fa-envelope-o animated"></i>
              </span>
              <span class="tag is-success counter">2</span>
            </a>
            <a class="navbar-item nav-tag">
              <span class="icon is-small">
                <i class="fa fa-bell-o animated"></i>
              </span>
              <span class="tag is-danger counter">6</span>
            </a>
            <div class="navbar-item has-dropdown is-hoverable">
              <a class="navbar-link">
                <figure class="image is-32x32" style="margin-right: 0.5em">
                  <img
                    src="https://avatars1.githubusercontent.com/u/7221389?v=4&amp;s=32"
                  />
                </figure>
                Admin
              </a>
              <div class="navbar-dropdown is-right">
                <a
                  class="navbar-item"
                  href="#"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span class="icon is-small">
                    <i class="fa fa-user-o"></i> </span
                  >&nbsp; Perfil
                </a>
                <hr class="navbar-divider" />
                <a class="navbar-item" @click.prevent="closeSession()">
                  <span class="icon is-small">
                    <i class="fa fa-power-off"></i> </span
                  >&nbsp; Cerrar Sesión
                </a>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </header>
    -->
    <template v-if="!['LoginView', 'register', 'help'].includes($route.name)">
      <Nav />
      <div class="app-shell">
        <aside class="app-shell__sidebar">
          <Menu />
        </aside>
        <main class="app-shell__main">
          <Breadcrumb v-if="1!=1" :itemList='[1, 2, 3]' />
          <router-view />
        </main>
      </div>
    </template>

    <div v-else class="app-shell app-shell--auth">
      <div class="app-shell__auth-view hero is-primary is-fullheight">
        <router-view />
      </div>
    </div>
  </div>
</template>
<style>
html,
body {
  min-height: 100%;
  background:
    radial-gradient(circle at top, rgba(236, 229, 219, 0.82), transparent 36%),
    linear-gradient(180deg, #f6f1e9 0%, #efe7dc 100%);
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  color: #2c3e50;
  min-height: 100vh;
}

.app-shell {
  display: grid;
  grid-template-columns: minmax(0, 280px) minmax(0, 1fr);
  gap: 1rem;
  align-items: start;
  width: 100%;
  max-width: 1680px;
  margin: 0 auto;
  padding: 0 0.75rem 1rem;
}

.app-shell__sidebar {
  min-width: 0;
}

.app-shell__main {
  min-width: 0;
  padding-top: 0.75rem;
}

.app-shell--auth {
  display: block;
  max-width: none;
  padding: 0;
}

.app-shell__auth-view {
  min-height: 100vh;
}

@media screen and (max-width: 768px) {
  #menu-toggle:checked + .nav-menu {
    display: block;
  }

  .app-shell {
    grid-template-columns: 1fr;
    gap: 0.75rem;
    padding: 0 0.5rem 0.75rem;
  }

  .app-shell__sidebar {
    display: none;
  }

  .app-shell__main {
    padding-top: 0.25rem;
  }
}
</style>
<script>
import auth from '@/auth/index'
import Breadcrumb from './components/breadcrumb'
import Menu from './components/menu'
import Nav from './components/nav'
export default {
  components: {
    Breadcrumb,
    Menu,
    Nav
  },
  methods: {
    closeSession() {
      auth.closeSession()
      this.$router.push({ name: 'LoginView' })
    }
  }
}
</script>
